import React, { useEffect, useMemo, useState } from "react";
import { ClockIcon, FlameIcon } from "lucide-react";
const TOTAL_SPOTS = 200;
function pad(n: number) {
  return n.toString().padStart(2, "0");
}
export function CountdownOffer() {
  // 3h countdown that persists within the session
  const target = useMemo(() => {
    const stored = sessionStorage.getItem("mp_countdown_target");
    if (stored) return parseInt(stored, 10);
    const t = Date.now() + 3 * 60 * 60 * 1000;
    sessionStorage.setItem("mp_countdown_target", String(t));
    return t;
  }, []);
  const [remaining, setRemaining] = useState(() => target - Date.now());
  useEffect(() => {
    const id = setInterval(() => setRemaining(target - Date.now()), 1000);
    return () => clearInterval(id);
  }, [target]);
  const clamped = Math.max(0, remaining);
  const hours = Math.floor(clamped / 3_600_000);
  const minutes = Math.floor(clamped % 3_600_000 / 60_000);
  const seconds = Math.floor(clamped % 60_000 / 1000);
  const spotsLeft = 37;
  const pct = Math.round(spotsLeft / TOTAL_SPOTS * 100);
  return <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4" data-id="element-58" data-mp="3fx0porrcuucn">
      <div className="mb-3 flex items-center justify-center gap-2 text-amber-700" data-id="element-59" data-mp="3fuwjg35zhj97">
        <FlameIcon className="h-5 w-5" fill="currentColor" strokeWidth={0} data-id="element-60" data-mp="3tnm7ed52oy8y" />
        <span className="text-sm font-extrabold uppercase tracking-wide" data-id="element-61" data-mp="3pnvcbx8ijvym">
          La oferta termina en
        </span>
      </div>

      <div className="mb-4 flex items-center justify-center gap-2" data-id="element-62" data-mp="31zc0j7q9911s">
        {[{
        v: hours,
        l: "Horas"
      }, {
        v: minutes,
        l: "Min"
      }, {
        v: seconds,
        l: "Seg"
      }].map((u, i) => <React.Fragment key={u.l} data-id="element-63" data-mp="3avjpkygp3bx4" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-64" data-mp="35yjpr5afv5eg">
              <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-slate-900 font-display text-2xl font-extrabold tabular-nums text-white" data-id="element-65" data-mp="3615yh892fqy9">
                {pad(u.v)}
              </div>
              <span className="mt-1 text-[11px] font-semibold uppercase text-slate-500" data-id="element-66" data-mp="3f0ka3lup5qx4">
                {u.l}
              </span>
            </div>
            {i < 2 && <span className="pb-5 text-2xl font-bold text-slate-400" data-id="element-67" data-mp="3jy3qaraygdrp">:</span>}
          </React.Fragment>)}
      </div>

      <div className="flex items-center justify-between text-sm font-semibold text-slate-700" data-id="element-68" data-mp="3nzfhh19h9720">
        <span className="flex items-center gap-1.5" data-id="element-69" data-mp="3sy8tsqd12s0l">
          <ClockIcon className="h-4 w-4 text-amber-600" data-id="element-70" data-mp="2wb3yo3hh4e1x" />
          Cupos restantes
        </span>
        <span className="font-extrabold text-amber-700" data-id="element-71" data-mp="30cpiy9wc7um5">
          {spotsLeft} / {TOTAL_SPOTS}
        </span>
      </div>
      <div className="mt-2 h-3 w-full overflow-hidden rounded-full bg-amber-100" data-id="element-72" data-mp="3597kz20a9eus">
        <div className="h-full rounded-full bg-amber-500 transition-all" style={{
        width: `${pct}%`
      }} data-id="element-73" data-mp="3a2iq8ypg5nkl" />
      </div>
      <p className="mt-2 text-center text-xs font-medium text-amber-700" data-id="element-74" data-mp="2ck8yxtt1hsk7">
        ¡Se están agotando rápido! Solo quedan {spotsLeft} plazas a este precio.
      </p>
    </div>;
}